

export default (function() {
  'use strict';

  /* eslint-disable no-unused-vars */

  var hamburger = document.querySelector('.mobile-icon');
  // Define our viewportWidth variable

  function initMobileMenu() {
    var hiddenNav = document.querySelector('.nav-primary');
    var close = hiddenNav.querySelector('.close');
    hamburger.addEventListener('click', function(){
      if(hiddenNav.classList.contains('open')){
        hiddenNav.classList.remove('open');
      } else {
        hiddenNav.classList.add('open');
      }
    })

    close.addEventListener('click', function(){
      if(hiddenNav.classList.contains('open')){
        hiddenNav.classList.remove('open');
      }
    })

  }

  function init() {
    if(hamburger) {
      initMobileMenu();
    }
  }

  return {
    init: init
  };


  /* eslint-enable no-unused-vars */

})()
